var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"trigger",attrs:{"title":_setup.isDisabled ? `${_setup.props.tooltipMessageDisabled}` : ''},on:{"click":_setup.openModal}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }